var _desc, _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuActivePixelied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(32.1615 0 0 32.1615 498.8735 499.1309)",
    id: 166393
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2 -10.5)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -15.5 -3)",
    x1: 2,
    y1: 4.53333,
    x2: 29,
    y2: 4.53333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(232,94,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(45,217,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "url(#SVGID_127)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -12.5,
    y1: 0,
    x2: 12.5,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2 0)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -19.5 -13.5)",
    x1: 6,
    y1: 15.0333,
    x2: 33,
    y2: 15.0333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(232,94,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(45,217,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "url(#SVGID_128)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -12.5,
    y1: 0,
    x2: 12.5,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2 10.5)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -15.5 -24)",
    x1: 2,
    y1: 25.5333,
    x2: 29,
    y2: 25.5333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(232,94,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(45,217,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "url(#SVGID_129)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x1: -12.5,
    y1: 0,
    x2: 12.5,
    y2: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuActivePixelied);
export default __webpack_public_path__ + "static/media/menu-active-pixelied.c6b68597ead2be05459427b0de4dc12b.svg";
export { ForwardRef as ReactComponent };